// A room's rules, as the Lobby lists show them (open online tables, the player's own tables).
import React from "react";
import { t } from "../../lib/i18n";

export const DEFAULT_PARAMS = {
  threshold_x: 71, elim_score_y: 501, num_jokers: 4, standard_penalty: 50, joker_in_hand_penalty: 50,
  useful_discard_penalty: 50, continuer_penalty: 50, nefrech_fausse_penalty_enabled: true, nefrech_fausse_penalty: 50,
  require_pure_sequence: true,
};

export const isDefaultParams = (r) =>
  r.threshold_x === DEFAULT_PARAMS.threshold_x &&
  r.elim_score_y === DEFAULT_PARAMS.elim_score_y &&
  r.num_jokers === DEFAULT_PARAMS.num_jokers &&
  (r.standard_penalty ?? 50) === DEFAULT_PARAMS.standard_penalty &&
  (r.joker_in_hand_penalty ?? 50) === DEFAULT_PARAMS.joker_in_hand_penalty &&
  (r.useful_discard_penalty ?? 50) === DEFAULT_PARAMS.useful_discard_penalty &&
  (r.continuer_penalty ?? 50) === DEFAULT_PARAMS.continuer_penalty &&
  (r.nefrech_fausse_penalty_enabled ?? true) === DEFAULT_PARAMS.nefrech_fausse_penalty_enabled &&
  (r.require_pure_sequence ?? true) === DEFAULT_PARAMS.require_pure_sequence;

export function ParamsPanel({ r }) {
  return (
    <div className="mt-2 pt-2 border-t border-slate-700/60 grid grid-cols-2 gap-x-4 gap-y-1 text-[10px]">
      {[
        [t("common.threshold"), t("common.pts", { n: r.threshold_x })],
        [t("common.elim"), t("common.pts", { n: r.elim_score_y })],
        [t("common.jokers"), r.num_jokers],
        [t("lobby.param.std"), r.standard_penalty ?? 50],
        [t("lobby.param.jokerHand"), r.joker_in_hand_penalty ?? 50],
        [t("lobby.param.useful"), r.useful_discard_penalty ?? 50],
        [t("lobby.param.continuer"), r.continuer_penalty ?? 50],
        [t("lobby.param.nefrechFausse"), (r.nefrech_fausse_penalty_enabled ?? true) ? `${r.nefrech_fausse_penalty ?? 50}` : "—"],
        [t("lobby.param.pureSeq"), (r.require_pure_sequence ?? true) ? t("common.yes") : t("common.no")],
      ].map(([label, val]) => (
        <div key={label} className="flex justify-between gap-1">
          <span className="text-slate-500">{label}</span>
          <span className="text-slate-300">{val}</span>
        </div>
      ))}
    </div>
  );
}
